// How long a flash stays up when the caller names no duration. 4 s rather than the 2 it was: at 2 s
// the "Your changes have been saved" confirmation was gone before it could be read, let alone
// announced in full by a screen reader.
export const DEFAULT_MILLISECONDS = 4000;

export class AlertFlashMessage {
    alertFlashName: string = '';
    type: string = '';
    static readonly TYPE = {
        success: 'success',
        info: 'info',
        warning: 'warning'
    };
    text: string = '';
}
